// @flow

import jwtDecode from 'jwt-decode'

export const decodedAccessToken = () => {
  const accessToken = localStorage.getItem('accessToken')
  const decodedAccessToken = jwtDecode(accessToken)
  return decodedAccessToken
}
